import { render, staticRenderFns } from "./apply.vue?vue&type=template&id=616b3af6"
import script from "./apply.vue?vue&type=script&lang=js"
export * from "./apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616b3af6')) {
      api.createRecord('616b3af6', component.options)
    } else {
      api.reload('616b3af6', component.options)
    }
    module.hot.accept("./apply.vue?vue&type=template&id=616b3af6", function () {
      api.rerender('616b3af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/education/apply.vue"
export default component.exports